var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 92,
    viewBox: "0 0 84 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.6667 82.8H9.33333V32.2H74.6667M60.6667 0V9.2H23.3333V0H14V9.2H9.33333C4.15333 9.2 0 13.294 0 18.4V82.8C0 85.24 0.98333 87.58 2.73367 89.3054C4.48401 91.0307 6.85798 92 9.33333 92H74.6667C77.142 92 79.516 91.0307 81.2663 89.3054C83.0167 87.58 84 85.24 84 82.8V18.4C84 15.96 83.0167 13.62 81.2663 11.8946C79.516 10.1693 77.142 9.2 74.6667 9.2H70V0M65.3333 50.6H42V73.6H65.3333V50.6Z",
    fill: "#024202"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.4f75860543ce85042b7397dac6bca065.svg";
export { ForwardRef as ReactComponent };